import type { ReactNode } from "react";

import { Navigate } from "react-router-dom";

import { useAuth } from "@/providers/AuthProvider";
import LoadingScreen from "@/components/loading-screen/loading-screen";
import { AppRoutes } from "@/config/app.routes";

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: Readonly<ProtectedRouteProps>) {
  const { authStatus } = useAuth();

  if (authStatus === "pending") {
    return <LoadingScreen />;
  }

  if (authStatus === "unauthenticated") {
    // `replace` prevents the login page appearing in browser history
    return <Navigate to={AppRoutes.LOGIN} replace />;
  }

  return <>{children}</>;
}
